import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import { useNavigate, Link } from "react-router-dom";
import Notiflix from "notiflix";

//ANT DESIGN IMPORTS
import {
  Layout,
  Input,
  Row,
  Typography,
  Card,
  Spin,
  Form,
  Collapse,
  Select,
  Col,
} from "antd";

//PROJECT IMPORTS
import TopContent from "../../../components/layouts/TopContent";
import appLabel from "../../../config/appLabel";
import appStatic from "../../../config/appStatic";
import definedApi from "../../../services/definedApi";
import { BOM } from "../../../services/definedMethod";
import cnt from "../../../services/definedConstant";

import "../../../assets/styles/DatePicker.css";
import MainLayout from "../../../components/layouts/MainLayout";
import RecordStatus from "../../../components/RecordStatus";

const { Content } = Layout;
const { Text, Title } = Typography;
const { Panel } = Collapse;

const ViewGLA1000 = (props) => {
  //DECLARED VARIABLES
  const { userData } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { state } = useLocation();
  const [useForm] = Form.useForm();
  const [fundSourceDetail, setFundSourceDetail] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    // console.log(state);
    getDetailById(state);
  }, []);

  const getDetailById = (params) => {
    setIsLoading(true);

    const url = `${definedApi.ViewFundSource}/${params.key}`;

    let body = {
      session,
    };

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objDetail = res;
        setFundSourceDetail(objDetail);

        // ENABLE DELETE BUTTON
        // dispatch({
        //   type: BOM.HasPermission("DELETE_FUND") && cnt.RIGHT_DELETE_BTN,
        // });

        setIsLoading(false);
      }
    });
  };

  // const handleOnDelete = () => {

  //     let action = "Delete  ";
  //     let label = state.name;
  //     // console.log(body);return

  //     Notiflix.Confirm.show(
  //         "Are you sure?",
  //         action + label,
  //         "Yes",
  //         "No",
  //         function () {
  //             // Yes
  //             const url = `${definedApi.DeleteFundSource}/${state.key}`;

  //             const body = {
  //                 method: "DELETE",
  //                 session,
  //             };

  //             setIsLoading(true);

  //             BOM.FetchReqAction(body, url, (err, res) => {
  //                 if (err) {
  //                     BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
  //                     setIsLoading(false);
  //                 } else {
  //                     BOM.AlertMsg(cnt.SUCCESS, appLabel.deleteFundSourceMsg);
  //                     navigate("/gla1000");
  //                     //STOP LOAD
  //                     setIsLoading(false);
  //                 }
  //             });
  //         },
  //         function () {
  //             // No button
  //         }
  //     );
  // };

  return (
    <MainLayout
      isEnableRightSidebar={true}
      // onDelete={handleOnDelete}
    >
      {/* PART 1  IMPORT TOP CONTENT*/}
      <TopContent
        pageTitle={appLabel.FundSourcedetail}
        pageItems={appStatic.viewFundSourceItems}
      />

      <Spin spinning={isLoading} size="large">
        {/* PART 2 DISPLAY CONTENT */}
        <Form
          form={useForm}
          layout="vertical"
          style={{ paddingTop: 20, marginBottom: 50 }}
        >
          <Card
            style={{
              boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
              borderRadius: 20,
            }}
            title={
              <Title level={4} style={{ color: "#000" }}>
                {appLabel.generalInfo}
              </Title>
            }
          >
            <Card
              style={{
                marginBottom: "2%",
                boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
              }}
            >
              <Row style={{ justifyContent: "space-between" }}>
                <Col span={12}>
                  <Form.Item label="name">
                    <Input
                      style={{ width: "30vh" }}
                      disabled
                      value={fundSourceDetail?.name}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Card>
          </Card>
        </Form>

        {/* PART 3 DISPLAY  RECORD STATUS */}
        <RecordStatus
          authStatus={""}
          makerID={""}
          makerDate={""}
          checkerID={""}
          checkerDate={""}
        />
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
});
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(ViewGLA1000);
